import React from 'react';

export const phoneSupport = '1-800-874-5881';
export const PhoneSupport = <a href={`tel:${phoneSupport}`}>{phoneSupport}</a>;

export const PhiAuthCommsPreferencesText =
  'We message you medication and order updates. Can we include health information (like medication names) in push notifications, text messages, and emails?';
export const PhiAuthCommsPreferencesTextWithoutPush =
  'We message you medication and order updates. Can we include health information (like medication names) in text messages and emails?';
